import React from "react";
import "../../App.css";

function Catherine() {
  return (
    <div className="aboutus-container">
      <h1 className="about-us">Catherine Yap</h1>
        <div class="aboutus-info">
          <div class="row">
            <div class="column">
              <div class="profileimg">
                <img src="images/catherine.jpg" alt="Catherine"></img>
              </div>
            </div>
            <div class="column">
            <div class="aboutus-offer">
              <p><strong>2016: Certificate IV in Community Languages Teaching</strong><br></br>
              Community Languages Victoria<br></br>
              (Australian Federation of Ethnic Schools Associations)<br></br>
              Co AS IT (Italian Centre), Carlton
              <br></br><br></br>
              <strong>2012: Graduate Diploma in Secondary Education</strong><br></br>
              Victoria University, Melbourne<br></br>
              Subject Methods: Science/Maths<br></br>
              
              <br></br>
              <strong>2011: Postgraduate Diploma in Biomedical Science</strong><br></br>
              The Ritchie Centre<br></br>
              Monash Institute of Medical Research<br></br>
              Monash University, Clayton<br></br>
              Research Project: The Role of Tregs in Human <br></br>
              Amnion Epithelial Cell Mediated Lung Repair<br></br>
              <br></br>
              <strong>2010: Bachelor of Science</strong><br></br>
              Monash University, Clayton Campus<br></br>
              Major: Genetics and Human Pathology<br></br>
              </p>
            </div>  
          </div>
        </div>
      </div>
    </div>
  );
}

export default Catherine;
